module.exports = __webpack_public_path__ + "static/media/reactImg.47ce6e77.png";